<h4>
  <fa-duotone-icon [icon]="faTableLayout"></fa-duotone-icon>
  <span>{{ 'Interface Settings' | translate }}</span>
</h4>

<div class="tile-settings">
  <andor-language-select />

  <div class="tabs-wrapper">
    <div class="tabs-label">
      {{ 'Limit video chat tiles' | translate }}
      <fa-icon
        class="info"
        [icon]="faInfoCircle"
        [andorTooltip]="
          'The maximum number of visible participants in video chat.' | translate
        "></fa-icon>
    </div>
    <andor-tabs [tabs]="tabs" [(active)]="activeTab"></andor-tabs>
  </div>
</div>

<h4>
  <fa-duotone-icon [icon]="faBell"></fa-duotone-icon>
  <span>{{ 'Notification Settings' | translate }}</span>
</h4>

<andor-mat-toggle-wrapper
  label="{{ 'Enable Notification Sounds' | translate }}"
  tooltipText="{{ 'Globally enable/disable notification sounds for the app.' | translate }}">
  <mat-slide-toggle
    (toggleChange)="toggleAppSounds()"
    [checked]="userSettingsStore.playAppSounds$ | async"></mat-slide-toggle>
</andor-mat-toggle-wrapper>
<andor-mat-toggle-wrapper
  label="{{ 'Enable Chat Sounds' | translate }}"
  tooltipText="{{ 'Play a sound when sending/receiving text messages.' | translate }}">
  <mat-slide-toggle
    (toggleChange)="toggleChatSounds()"
    [checked]="userSettingsStore.playChatSounds$ | async"
    [disabled]="!(userSettingsStore.playAppSounds$ | async)"></mat-slide-toggle>
</andor-mat-toggle-wrapper>
<andor-mat-toggle-wrapper
  label="{{ 'Enable Participant Sounds' | translate }}"
  tooltipText="{{ 'Play a sound when participants join or leave the room.' | translate }}">
  <mat-slide-toggle
    (toggleChange)="toggleJoinLeaveSounds()"
    [checked]="userSettingsStore.playJoinedLeftSounds$ | async"
    [disabled]="!(userSettingsStore.playAppSounds$ | async)"></mat-slide-toggle>
</andor-mat-toggle-wrapper>

<h4>
  <fa-duotone-icon [icon]="faGear"></fa-duotone-icon>
  <span>{{ 'Chat' | translate }}</span>
</h4>

<div class="tile-settings">
  <div class="tabs-wrapper">
    <div class="tabs-label">
      {{ 'Layout' | translate }}
      <fa-icon
        class="info"
        [icon]="faInfoCircle"
        [andorTooltip]="
          'How chat messages are arranged. Left-aligned puts every message on the left (default). Sided puts your messages on the right and remote messages on the left.'
            | translate
        "
        [tooltipTitle]="'Layout' | translate"></fa-icon>
    </div>
    <andor-tabs [tabs]="chatLayoutTabs" [(active)]="activeChatLayoutTab"></andor-tabs>
  </div>

  <div class="tabs-wrapper">
    <div class="tabs-label">
      {{ 'Keep chat history' | translate }}
      <fa-icon
        class="info"
        [icon]="faInfoCircle"
        [andorTooltip]="
          'How long chat messages are kept on this device. Older messages are discarded. Set to Off to disable persistence and remove the stored history; currently displayed messages are kept.'
            | translate
        "
        [tooltipTitle]="'Keep chat history' | translate"></fa-icon>
    </div>
    <andor-tabs [tabs]="retentionTabs" [(active)]="activeRetentionTab"></andor-tabs>
  </div>

  <div class="delete-history">
    <div class="tabs-label">
      {{ 'Delete chat history' | translate }}
      <fa-icon
        class="info"
        [icon]="faInfoCircle"
        [andorTooltip]="
          'Permanently removes all chat messages stored on this device, in every room.' | translate
        "></fa-icon>
    </div>
    <andor-square-icon-btn
      variant="danger"
      [tooltip]="'Delete chat history' | translate"
      [ariaLabel]="'Delete chat history' | translate"
      (clicked)="deleteChatHistory()">
      <fa-icon [icon]="faTrash"></fa-icon>
    </andor-square-icon-btn>
  </div>
</div>

<!-- The native app has no legacy protocol: its backend only speaks HTTP/3. -->
@if (!isTauri) {
  <h4>
    <fa-duotone-icon [icon]="faNetworkWired"></fa-duotone-icon>
    <span>{{ 'Network Settings' | translate }}</span>
  </h4>

  <andor-mat-toggle-wrapper
    label="{{ 'Use Legacy Protocol' | translate }}"
    tooltipText="{{
      'Always use legacy networking with secure WebSockets and WebRTC instead of HTTP/3.' | translate
    }}">
    <mat-slide-toggle (toggleChange)="updateWebRTC()" [checked]="useWebRTC()"></mat-slide-toggle>
  </andor-mat-toggle-wrapper>
}

<h4>
  <fa-duotone-icon [icon]="faGear"></fa-duotone-icon>
  <span>{{ 'Miscellaneous Settings' | translate }}</span>
</h4>

<andor-mat-toggle-wrapper
  label="{{ 'Stop Microphone on Mute' | translate }}"
  tooltipText="{{
    'Turn off the microphone completely when muting yourself. Disable this to avoid audio issues with certain hardware or drivers.'
      | translate
  }}">
  <mat-slide-toggle
    (toggleChange)="updateStopMicAccessOnMute()"
    [checked]="stopMicAccessOnMute()"></mat-slide-toggle>
</andor-mat-toggle-wrapper>
